import { createRoutes } from 'shared/hocs'

import { ChartsOverview } from './overview'

export const Charts = createRoutes(({ match }) => [
  {
    exact: true,
    path: match.path,
    component: ChartsOverview,
  },
])
